import React from 'react';
import {
  Badge,
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Skeleton,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { RemoteSessionLog } from '../types';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  sessionId: string | null;
  logs: RemoteSessionLog[];
  loading: boolean;
}

const STATUS_COLOR: Record<string, string> = {
  success: 'green',
  failed: 'red',
  pending: 'yellow',
};

const fmt = (iso: string) =>
  new Date(iso).toLocaleString('id-ID', { dateStyle: 'short', timeStyle: 'medium' });

const SaktiRemoteSessionLogModal: React.FC<Props> = ({ isOpen, onClose, sessionId, logs, loading }) => (
  <Modal isOpen={isOpen} onClose={onClose} size="5xl" scrollBehavior="inside">
    <ModalOverlay />
    <ModalContent>
      <ModalHeader fontSize="md">
        Audit Log Sesi
        {sessionId && (
          <Text as="span" fontSize="xs" color="gray.400" ml={2} fontFamily="mono">
            {sessionId.slice(0, 8)}…
          </Text>
        )}
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody pb={6}>
        {loading ? (
          <Box>{[1, 2, 3, 4].map((i) => <Skeleton key={i} height="36px" mb={2} />)}</Box>
        ) : logs.length === 0 ? (
          <Text fontSize="sm" color="gray.400" textAlign="center" py={4}>
            Tidak ada log untuk sesi ini.
          </Text>
        ) : (
          <Box overflowX="auto">
            <Table size="sm" variant="simple">
              <Thead bg="gray.50" position="sticky" top={0}>
                <Tr>
                  <Th fontSize="xs">Waktu</Th>
                  <Th fontSize="xs">Aksi</Th>
                  <Th fontSize="xs">Tabel</Th>
                  <Th fontSize="xs">Query</Th>
                  <Th fontSize="xs">Status</Th>
                  <Th fontSize="xs">Baris</Th>
                  <Th fontSize="xs">Error</Th>
                </Tr>
              </Thead>
              <Tbody>
                {logs.map((log) => (
                  <Tr key={log.id} _hover={{ bg: 'gray.50' }}>
                    <Td fontSize="xs" whiteSpace="nowrap">{fmt(log.created_at)}</Td>
                    <Td>
                      <Badge colorScheme="purple" fontSize="0.6rem">{log.action_type}</Badge>
                    </Td>
                    <Td fontSize="xs" fontFamily="mono">{log.target_table ?? '-'}</Td>
                    <Td fontSize="xs" fontFamily="mono" maxW="220px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" title={log.query_statement ?? ''}>
                      {log.query_statement ?? '-'}
                    </Td>
                    <Td>
                      <Badge colorScheme={STATUS_COLOR[log.status] ?? 'gray'} fontSize="0.6rem">
                        {log.status}
                      </Badge>
                    </Td>
                    <Td fontSize="xs" isNumeric>{log.rows_affected}</Td>
                    <Td fontSize="xs" color="red.500" maxW="160px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
                      {log.error_message ?? '-'}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
        )}
      </ModalBody>
    </ModalContent>
  </Modal>
);

export default SaktiRemoteSessionLogModal;
